<template>
  <div id="markeredition">

    <loading
      :active="isLoadingInfo"
      :can-cancel="false"
      :is-full-page="false"
    />
    <div
      style="text-align:left"
    >
      <h4> <input-color-picker
        v-if="img !== ''"
        v-model="colorPicker"
        @change="colorPickerChange" 
      /> {{ data.marker }}</h4>
      <div id="content">
        <div
          v-if="img !== ''"
          id="picture"
        >
          <loading
            :active="isLoading"
            :can-cancel="false"
            :is-full-page="false"
          />
          <img
            v-if="img!== ''"
            :src="img"
            class="markerImg"
          >
        </div>
        <div
          v-if="img !== ''"
          id="histograms"
        >
        <div id="histograms_content">
          <HistogramSlider
            v-if="histogram.histogram_x !== undefined"
            :data="histogram"
          />
          <!---
        
          <range-slider
          v-if="histogram_x.length > 0"
          class="slider"
          :min="minsat"
          :max="maxsat"
          :step="0.1"
          :tooltip="true"
          @slideEnd = "slideEnd"
          :v-model="newsaturation">
        </range-slider>-->


 <div class="range_container">
    <div class="sliders_control">
   
       <input ref="fromSlider" type="range" :tooltip="newsaturation_s" v-model="newsaturation_s" :min="minsat" :max="maxsat" step="0.1" @change="slideEnd"/>
      <!---- <output for="distance" :value="newsaturation_s" class="range-slider-tooltip">{{ newsaturation_s }}</output>-->
       <input ref="toSlider" type="range" v-model="newsaturation_e" :min="minsat" :max="maxsat" step="0.1" @change="slideEnd"/>
    </div>
    <div class="form_control">
      <div class="form_control_container">
          <div class="form_control_container__time">Min</div>
          <input class="form_control_container__time__input" type="number" ref="fromInput" v-model="newsaturation_s" :min="minsat" step="0.1" :max="maxsat"  @change="changeData"/>
        </div>
        <div class="form_control_container">
          <div class="form_control_container__time">Max</div>
          <input class="form_control_container__time__input" type="number" ref="toInput" v-model="newsaturation_e" step="0.1" :min="minsat" :max="maxsat"  @change="changeData"/>
        </div>
    </div>
</div>

    <vue-range-slider
            v-if="test_jorge"
            @keydown.prevent="onClick" 
            v-model="newsaturation"
            style="margin-left:10px"
            class="sat_slider"
            :step="0.1"
            :max="maxsat"
            :min="minsat"
            :bg-style="bgStyle"
            :tooltip-style="tooltipStyle"
            :process-style="processStyle"
            :real-time="false"
            :lazy="true"
            :use-keyboard ="true"
            :tooltip-dir="['bottom', 'bottom']"
          /> 
      <br><br>
        </div>
      <!-- <div>Adjust 99% luminosity: </div>
      <div style="margin-top:6px">
          <toggle-button :value="true"
              v-model="change_percent"
              color="#82C7EB"
              :labels="{checked: 'On', unchecked: 'Off'}"/>

      </div> -->

      
          <!-- <h5>Brightness</h5>
          <vue-range-slider
            v-model="newbrightness"
            style="margin-left:10px"
            :step="0.01"
            :max="1.5"
            :min="0.5"
            :bg-style="bgStyle"
            :tooltip-style="tooltipStyle"
            :process-style="processStyle"
            :real-time="false"
            :lazy="true"
            :tooltip-dir="['left', 'right']"
          />
          <h5>Contrast</h5>
          <vue-range-slider
            v-model="newcontrast"
            style="margin-left:10px"
            :step="0.01"
            :max="10"
            :min="0"
            :bg-style="bgStyle"
            :tooltip-style="tooltipStyle"
            :process-style="processStyle"
            :real-time="false"
            :lazy="true"
            :tooltip-dir="['left', 'right']"
          /> -->
        
          <b-button
            v-if="false"
            variant="outline-primary"
            class="mt-2"
            @click="refreshMarker"
          >
            REFRESH IMAGE
          </b-button>
        </div>
      </div> 
    </div>
  </div>
</template>
<script>
import { BButton } from 'bootstrap-vue'
import InputColorPicker from 'vue-native-color-picker'

//import  VueRangeSlider  from 'vue-range-component'


import store from '@/store/index'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import HistogramSlider from './HistogramSlider.vue'
import 'vue-loading-overlay/dist/vue-loading.css'
import { ToggleButton } from 'vue-js-toggle-button'
//import { AisRangeInput } from 'vue-instantsearch';
import RangeSlider from 'range-slider-vue';


const { url, port, auth } = store.state.appConfig.api
const headers = {
  authentication: auth,
  'Content-Type': 'application/json',
}
    function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
        if (from > to) {
            fromSlider.value = to;
            fromInput.value = to;
        } else {
            fromSlider.value = from;
        }
    }
    
function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, '#C6C6C6', '#25daa5', controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
        toSlider.value = to;
        toInput.value = to;
    } else {
        toInput.value = from;
    }
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromInput.value = from;
  }
}

function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#25daa5', toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
    toSlider.value = from;
  }
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    console.log("FILL SLIDE", from, to)
    const rangeDistance = to.max-to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
      ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
      ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
      ${sliderColor} 100%)`;
}

function setToggleAccessible(currentTarget) {
  const toSlider = document.querySelector('#toSlider');
  if (Number(currentTarget.value) <= 0 ) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}


export default {
  components: {
    RangeSlider,
    InputColorPicker,
    HistogramSlider,
    BButton,
    Loading,
    ToggleButton
  },
  props: {
    data: {
      required: true,
      type: [Object, String],
      default: null,
    }, 
    changeMarkerColor: {
      required: true,
      type: Function,
      default: () => {},
    },
    color: {
      required: true,
      type: [Object, String],
      default: '#000',
    },
    name: {
      required: true,
      type: [Object, String],
      default: '',
    },
    brightness: {
      required: true,
      type: [Object, String, Number],
      default: 0,
    },
    contrast: {
      required: true,
      type: [Object, String, Number],
      default: 0,
    },
    saturation: {
      required: false,
      type: [Object, String, Number, Array],
      default: () => [this.minsat, this.maxsat],
    }
  },
  data() {
    return {
      test_jorge: false,
      isLoadingInfo: true,
      change_percent: false,
      newcolor: this.color,
      colorPicker: this.color,
      histogram_x: [],
      histogram_y: [],
      histogram: {},
      update: 0,
      img: '',
      isLoading: false,
      newbrightness: this.brightness,
      newcontrast: this.contrast,
      newsaturation: this.saturation,
      newsaturation_s:this.saturation[0] ?? 0,
      newsaturation_e: this.saturation[1] ?? 10,
     
      bgStyle: {
        backgroundColor: '#fff',
        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
      },
      tooltipStyle: {
        backgroundColor: '#666',
        borderColor: '#666',
      },
      processStyle: {
        backgroundColor: '#999',
      },
    }
  },
  created() {
    this.$root.$refs.preview = this;
  
   
  },
  computed: {
    minsat() {
      console.log("MINSATURATION",this.histogram_x[0])
      if(this.newsaturation_s == 0){
        this.newsaturation_s = Math.round( this.histogram_x[0] * 100 ) /100;
      }
     
     // return Number(this.histogram_x[0])
      return ((this.histogram_x.length === 0) ? 0 : Math.ceil((this.histogram_x[0] + Number.EPSILON) * 100) / 100)
     
    },
    maxsat() {
      if(this.newsaturation_e == 10){
        this.newsaturation_e = Math.round ( this.histogram_x[1] * 100) / 100
      }
      console.log("MAS SATURATION", this.histogram_x)
      return ((this.histogram_x.length === 0) ? 100 : Math.ceil((this.histogram_x.at(-1) + Number.EPSILON) * 100) / 100)
    },
  },
  watch: {
    maxsat(from, to){
      if (to ==100 && from != 100 ){
        try{
        this.newsaturation_s = Math.round (this.newsaturation[0] * 100) / 100 ;
        if(this.newsaturation[1] != 100){
          this.newsaturation_e = this.newsaturation[1];
        }
        else{
          this.newsaturation_e = Math.ceil(from * 100) / 100;
        }
      }catch{
        this.newsaturation_e = Math.floor(from * 100) / 100;
      }
      
     
    
        }
     
    },
 
    change_percent(value){
      if (!this.isLoading)
        this.refreshMarker()
    },
    img: function(value){
       if(value != ''){this.isLoadingInfo = false;}
    },
    img(to, from) {
      if (from === '') {
        // console.log('img', this.img)
        this.getData()
      }
     
    },
    newcolor() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newbrightness() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newcontrast() {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
      if (!this.isLoading)
        this.refreshMarker()
    },
    newsaturation(to, from) {
      const { newbrightness, newcontrast, newsaturation } = this
      const filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1],
      }
      this.changeMarkerColor(this.data.path, this.data.name, this.newcolor, filters)
    
        this.refreshMarker()
    },
  },
  mounted() {
    this.refreshMarker()

  },
  methods: {
    changeData(){
      console.log("CHANGE")
    },
    onClick(e){
      
      console.log("onClick", e)
    },
   
    slideEnd() {
   
      const { newsaturation_e, newsaturation_s} = this
      this.newsaturation = [Number(newsaturation_s), Number(newsaturation_e)]
  
    
    },
    set_preview(new_image){
    //    if(this.$parent.isLoading == false){
        this.img = `data:image/jpg;base64,${new_image}`
      this.isLoadingInfo = false;

    //  }
  
    },
    colorPickerChange(color){
      this.newcolor = color
    },
    getData() {
      const { marker, id, path } = this.data
      //this.isLoadingInfo = true;
      axios.get(`${url}:${port}/viewer-marker/${id}/${marker}`, { headers }).then(response => {
        if (response) {
          const { data } = response.data
          const { metadata } = data
          if (metadata[path] !== undefined) {
            const markerData = metadata[path]
            this.histogram_x = markerData.histogramx
            this.histogram_y = markerData.histogramy
            this.histogram = { histogram_x: markerData.histogramx, histogram_y: markerData.histogramy }
            console.log("DATA", metadata)
            // console.log({ histogram_x: markerData.histogramx, histogram_y: markerData.histogramy })
            // this.params = data
           // this.newsaturation = [Math.floor(this.minsat), Math.floor(this.minsat)]
            // console.log('trace', 'newsaturation', this.newsaturation)
            this.update = new Date().getTime()
           // this.isLoadingInfo = false
          }
        }
        // console.log(response)
      })
    },
    refreshMarker() {
       this.isLoading = true
      const {
        data, newbrightness, newcontrast, newcolor, newsaturation,
      } = this
      const { id, coordinates, path } = data
      const coor = (coordinates !== undefined) ? coordinates : {
        left: 0, top: 0, width: 0, height: 0,
      }
    
      var filters = {
        brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1], perce_lumi_corr: 99
      }
      if(this.change_percent == false){
        filters = {  brightness: newbrightness, contrast: newcontrast, saturation_min: newsaturation[0], saturation_max: newsaturation[1] }
      }
      const imgdata = {
        id, path, region: [coor.left, coor.top, coor.width, coor.height], filters, color: newcolor,
      }
      axios.post(`${url}:${port}/viewer-preview-image/${id}`, JSON.stringify(imgdata), { headers }).then(response => {
        if (response) {
          console.log('VIEWER JORGE', imgdata)
          // this.refreshTab()
         // this.img = `data:image/jpg;base64,${response.data.img}`
         this.isLoading = false
        }
      })
    }, 
  },
}
</script>
<style>
.range_container {
  display: flex;
  flex-direction: column;
  width: 250px;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 20px !important;
 
}

.range_container .sliders_control {
  position: relative;
  min-height: 30px;
  
}
.form_control {
  position: relative;
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  color: #635a5a;
}

.range_container input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px #C6C6C6;
  cursor: pointer;
}

.range_container input[type=range]::-moz-range-thumb {
  -webkit-appearance: none;
  pointer-events: all;
  width: 24px;
  height: 24px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 1px #C6C6C6;
  cursor: pointer;  
}

.range_container input[type=range]::-webkit-slider-thumb:hover {
  background: #f7f7f7;
}

.range_container input[type=range]::-webkit-slider-thumb:active {
  box-shadow: inset 0 0 3px #387bbe, 0 0 9px #387bbe;
  -webkit-box-shadow: inset 0 0 3px #387bbe, 0 0 9px #387bbe;
}
.range_container .form_control_container__time{
  font-size: 20px;
}

.range_container input[type="number"] {
  color: #8a8383;
  width: 50px;
  height: 30px;
  font-size: 20px;
  border: none;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button {  
   opacity: 1;
}

.range_container input[type="range"] {
  -webkit-appearance: none; 
  appearance: none;
  height: 2px;
  width: 100%;
  position: absolute;
  background-color: #C6C6C6;
  pointer-events: none;
}
.range-slider-holder {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 0 auto 84px;



}

.range-slider-tooltip {
  position: absolute;
  bottom: -51px;
  margin: 0;
  padding: 2px 16px;
  background: #122C35;
  border-radius: 5px;
  color: white;
  font-size: 2rem;
  font-weight: 600;
}


.range-slider-tooltip:before {
  content: '';
  display: block;
  position: absolute;
  top: -16px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 16px 16px 16px;
  border-color: transparent transparent #122C35 transparent;
}

#fromSlider {
  height: 0;
  z-index: 1;
}
.icp__input {
    height: 20px!important;
    width: 20px!important;
    margin-right:10px;
}
.swal2-actions button{
 margin: 0 10px;
}
.vue-range-slider.slider-component {
  margin-left:0px!important;
}
.sat_slider{
    margin-top: -30px!important;
    margin-bottom: 20px!important;
}
.sliders_control .tooltip {
    position: absolute;
    top: -1em;
    left: 0;
    display: none;
    background: #fff;
    border: 1px solid #000;
    min-width: 2em;
    padding: 4px;
    border-radius: 2px;
    text-align: center;
}
/* .vue-js-switch .v-switch-core[data-v-25adc6c0] {
    background-color: dodgerblue !important;
} */
.round-bar-track   {
height : 5px  !important;
}
.track-round {
  background-color: #0096ce !important;
}
.track-ball-left.track-ball ,
.track-ball-right.track-ball {

  height: 20px !important;
  width: 20px !important;
  top : -8px !important;
  background-color: #0096ce !important;

}
.round-bar.slider{
  margin-top: 0px  !important;
  margin-bottom: 20px  !important;

}
</style>
<style scoped>

h4{
    display: flex;
    align-items: flex-start;
}
#content{
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: space-between;
}
#picture{
    width: 55%;
    display: flex;
    align-items: center;
}
#picture img{
    max-width: 90%;
    max-height: 365px
}
#histograms{
    width: 40%;
}




</style>
